import { Button, CheckmarkInput, CloseIcon, Header, IconButton } from "@datagame/ui";
import { useMediaQuery } from "react-responsive";

import { isWordPresent } from "../../../../utils/isWordPresent";
import { useTranslation } from "react-i18next";
import { useWordopolis } from "../../../../hooks/useWordopolis";
import { WordopolisActionKind } from "../../../../reducers/wordopolis";
import { WordopolisDifficulty } from "../../../../gql/graphql";
import { WordopolisModal } from "../WordopolisModal";
import easyDifficulty from "../../../../assets/images/wordopolisEasy.png";
import mediumDifficulty from "../../../../assets/images/wordopolisMedium.png";
import hardDifficulty from "../../../../assets/images/wordopolisHard.png";

import styles from "./WordsListModal.module.scss";

const difficultyImages = {
  [WordopolisDifficulty.Easy]: easyDifficulty,
  [WordopolisDifficulty.Medium]: mediumDifficulty,
  [WordopolisDifficulty.Hard]: hardDifficulty,
};

export const WordsListModal = () => {
  const [
    {
      configuration: {
        words,
        difficulty,
        gameVisuals: { themeColor },
      },
      status: { foundWords, showWords },
    },
    dispatch,
  ] = useWordopolis();
  const { t } = useTranslation();
  const isDesktop = useMediaQuery({ query: "(min-width: 1280px)" });

  const handleClose = () => dispatch({ type: WordopolisActionKind.TOGGLE_SHOW_WORDS });

  if (isDesktop || !showWords) {
    return null;
  }

  return (
    <WordopolisModal isVisible={showWords} className={styles.modal} onClickOutside={handleClose}>
      <div className={styles.headline}>
        <Header variant="h6">{t("wordopolis.modals.words.header")}</Header>
        <IconButton size="small" onClick={handleClose} icon={<CloseIcon />} />
      </div>
      <span className={styles.difficulty}>
        {t("wordopolis.difficulty.word")}:
        <img src={difficultyImages[difficulty]} alt="difficulty-level" />
        <span className={styles.bold}>{t(`wordopolis.difficulty.${difficulty}`)}</span>
      </span>
      <div className={styles.list}>
        {words.map(({ value, description }, index) => (
          <CheckmarkInput
            disabled={true}
            type="checkbox"
            className={styles.word}
            customColor={themeColor}
            key={index}
            id={value}
            name="word"
            value={isWordPresent(value, foundWords)}
            label={description ?? value.toUpperCase()}
            unchangable={true}
          />
        ))}
      </div>
      <Button
        className={styles.closeBtn}
        customColor={themeColor}
        icon={<CloseIcon />}
        iconSide="left"
        onClick={handleClose}
      >
        {t("close")}
      </Button>
    </WordopolisModal>
  );
};
